<template>
    <v-container v-if="form" fluid class="pt-3">
        <v-row v-if="isForm">
            <v-col>
                <h5 class="subtitle-2">
                    Billing
                </h5>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-text-field
                    v-model="form.company_id"
                    :readonly="is_disabled"
                    type="number"
                    label="Company ID"
                    :error-messages="companyErrors"
                    @input="$v.form.company_id.$touch()"
                    @blur="$v.form.company_id.$touch()">
                </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <v-text-field
                    v-model="form.org_id"
                    :readonly="is_disabled"
                    type="number"
                    label="Organisation ID"
                    :error-messages="organizationErrors"
                    @input="$v.form.org_id.$touch()"
                    @blur="$v.form.org_id.$touch()">
                </v-text-field>
            </v-col>
        </v-row>

        <!-- Setup Charged -->
        <v-row>
            <v-col md="3">
                <v-switch
                    label=""
                    :readonly="is_disabled"
                    v-model="form.setup_charged">
                    <template v-slot:label>
                        <span>Setup Charged</span>
                    </template>
                </v-switch>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-text-field
                    type="number"
                    v-model="form.setup_fee"
                    :error-messages="setupFeeError"
                    :readonly="is_disabled"
                    @input="$v.form.setup_fee.$touch()"
                    @blur="$v.form.setup_fee.$touch()"
                    label="Setup Fee">
                </v-text-field>
            </v-col>

            <v-col cols="12" md="3">
                <v-menu
                    v-model="dateChargeSetupMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :readonly="is_disabled"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.charge_setup_on"
                            label="Charge Setup on"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="form.charge_setup_on"
                        @input="dateChargeSetupMenu = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
        </v-row>


        <!-- Monthly Charged-->
        <v-row>
            <v-col md="3">
                <v-switch
                    :readonly="is_disabled"
                    v-model="form.monthly_charged"
                    label="">
                    <template v-slot:label>
                        <span>Monthly Charged</span>
                    </template>
                </v-switch>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-text-field
                    type="number"
                    v-model="form.monthly_fee"
                    :error-messages="monthlyFeeError"
                    :readonly="is_disabled"
                    @input="$v.form.monthly_fee.$touch()"
                    @blur="$v.form.monthly_fee.$touch()"
                    label="Monthly Fee">
                </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :readonly="is_disabled"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.charge_monthly_from"
                            label="Charge Monthly From"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="form.charge_monthly_from"
                        @input="dateMenu = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
        </v-row>

        <v-row v-if="isForm">
            <v-col>
                <v-btn type="submit" small class="mr-1" color="primary" :disabled="isSubmit" >
                    <v-progress-circular
                        v-if="isSubmit"
                        indeterminate
                        size="12"
                        width="2"
                        color="primary"
                        class="mr-1">
                    </v-progress-circular>
                    Update
                </v-btn>
            </v-col>
        </v-row>
    </v-container>

</template>

<script>

import { numeric } from 'vuelidate/lib/validators'


export default {
    props: {
        form: { type: Object, default: () => null },
        isForm: { type: Boolean, default: false }, // This will indicate that this component wil have its own form submit
        is_disabled: { type: Boolean, default: false },
    },

    validations: {
        form: {
            company_id: { numeric },
            org_id: { numeric },
            setup_fee: { numeric },
            monthly_fee: { numeric },
            setup_charged: { numeric },
            monthly_charged: { numeric },
        }
    },

    data() {
        return {
            dateMenu: null,
            dateChargeSetupMenu: null,
            isSubmit: false,
        }
    },


    computed: {
        companyErrors() {
            const errors = []
            if (!this.$v.form.company_id.$dirty) return errors
            !this.$v.form.company_id.numeric && errors.push('Company id must be numeric')
            return errors
        },
        organizationErrors() {
            const errors = []
            if (!this.$v.form.org_id.$dirty) return errors
            !this.$v.form.org_id.numeric && errors.push('Orgnaization id must be numeric')
            return errors
        },
        setupFeeError() {
            const errors = []
            if (!this.$v.form.org_id.$dirty) return errors
            !this.$v.form.org_id.numeric && errors.push('Setup fee must be numeric')
            return errors
        },

        monthlyFeeError() {
            const errors = []
            if (!this.$v.form.org_id.$dirty) return errors
            !this.$v.form.org_id.numeric && errors.push('Monthly fee must be numeric')
            return errors
        },
    }
}
</script>
